import type React from 'react';

function GELExpressLogistikIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 406.44 418.35"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>GEL Express Logistik Icon</title>
      <defs>
        <clipPath id="clippath">
          <path
            d="M12.62,22.71c-4.58,0-8.3,3.71-8.3,8.28V404.84c0,4.57,3.72,8.28,8.3,8.28H387.33c4.58,0,8.3-3.7,8.3-8.28V30.99c0-4.57-3.71-8.28-8.3-8.28,0,0-374.71,0-374.71,0Z"
            fill="none"
          />
        </clipPath>
      </defs>

      <g id="Layer_2" data-name="Layer 2">
        <g clipPath="url(#clippath)">
          <g>
            <polygon
              points="190.87 184.38 199.5 195.66 210.56 186.8 201.93 175.5 190.87 184.38 190.87 184.38"
              fill="inherit"
            />
            <polygon
              points="196.53 143.26 205.17 154.54 216.22 145.68 207.59 134.38 196.53 143.26 196.53 143.26"
              fill="inherit"
            />
            <polygon
              points="240.49 126.33 249.12 137.61 260.17 128.75 251.54 117.45 240.49 126.33 240.49 126.33"
              fill="inherit"
            />
            <polygon
              points="198.97 104.83 207.59 116.11 218.91 107.25 210.02 95.95 198.97 104.83 198.97 104.83"
              fill="inherit"
            />
            <polygon
              points="225.66 156.42 234.29 167.72 245.34 158.84 236.72 147.56 225.66 156.42 225.66 156.42"
              fill="inherit"
            />
            <polygon
              points="266.91 68.82 258.29 57.52 247.24 66.4 255.86 77.68 266.91 68.82 266.91 68.82"
              fill="inherit"
            />
            <polygon
              points="263.68 144.33 272.31 155.62 283.36 146.75 274.74 135.46 263.68 144.33 263.68 144.33"
              fill="inherit"
            />
            <polygon
              points="155.28 158.04 163.9 169.33 174.96 160.46 166.34 149.17 155.28 158.04 155.28 158.04"
              fill="inherit"
            />
            <polygon
              points="249.93 100.79 241.29 89.51 230.24 98.37 238.87 109.67 249.93 100.79 249.93 100.79"
              fill="inherit"
            />
            <polygon
              points="152.04 197 160.67 208.3 171.73 199.42 163.1 188.14 152.04 197 152.04 197"
              fill="inherit"
            />
            <polygon
              points="279.85 113.15 288.49 124.71 299.54 115.84 290.91 104.56 279.85 113.15 279.85 113.15"
              fill="inherit"
            />
            <polygon
              points="314.89 49.52 304.25 57.79 312.64 69.01 323.27 60.48 314.89 49.52 314.89 49.52"
              fill="inherit"
            />
            <path
              d="M362.41,0l5.63,7.37-4.2,3.37L355.63,0h-4.34l1.24,1.62-5.68,4.55-4.72-6.18h-10.47l-4.49,3.49,8.48,11.36-7.49,6-8.55-11.18-11.32,8.6,8.72,11.32-10.34,8.3,8.37,10.96,10.05-8.06,.2,.25,8.43,11.03-10.47,8.39,8.63,11.28,10.47-8.39,.05,.07h0l.02,.03,.14,.18h0l8.41,11.01-10.47,8.39-8.63-11.28-11.06,8.87-8.37-10.96-10.64,8.54,8.63,11.28,11.06-8.87,8.63,11.28,11.06-8.87,8.63,11.28,11.06-8.87-8.58-11.23,8.83-7.08,.04,.04,8.62,11.27,11.05-8.87-8.61-11.26,6.56-5.26,8.52,11.15,11.06-8.87-8.51-11.13,4.5-3.6,8.6,11.25,3.51-2.81V10.61l-3.69-7.45L396.61,.02h-34.19Zm-25.5,13.62l6.6-5.29m-17.75,32.04l-.05-.07h0l-8.45-11.05,8.53-6.84,8.5,11.12-8.53,6.84h0Zm17.25,22.58l-.05-.07h0l-8.58-11.23,8.83-7.08,.25,.34h0l8.37,10.95-8.83,7.08h0Zm1.86-19.65l-.03-.03-8.56-11.2,7.68-6.01,8.43,11.02,.09,.12-7.6,6.1h0Zm15.62-30.38l8.37,10.96-5.25,4.21-8.54-10.82,5.42-4.35h0Zm.35,17.57l8.55,11.18h0l.09,.11-6.62,5.18-8.57-11.21h0l-.07-.09,6.62-5.18h0Zm1.28,35.41l-.02-.03-8.61-11.26,7.61-6.11,8.8,11.16-7.78,6.23h0ZM374.87,1.75l8.4,11.01-3.27,2.63-8.32-11.14,3.19-2.5h0Zm-2.79,20.13l4.42-3.44,8.41,11.01-4.5,3.6-8.35-11.18h0Zm8.78,28.78l-8.28-10.82h0l-.32-.42,5.45-4.23,.02,.04,8.51,11.13-5.38,4.32h0Zm8.98-42.93l8.5,10.99-2.37,1.85-8.41-11.01,2.28-1.83h0Zm7.54,29.85l-8.5-11.12,3.28-2.63,8.7,10.96-3.49,2.79h0Z"
              fill="inherit"
            />
            <polygon
              points="289.83 87.09 281.21 75.53 270.15 84.4 278.78 95.68 289.83 87.09 289.83 87.09"
              fill="inherit"
            />
            <polygon
              points="287 35.21 295.63 46.51 306.69 37.9 298.05 26.35 287 35.21 287 35.21"
              fill="inherit"
            />
            <polygon
              points="280.94 57.79 289.56 69.08 300.62 60.21 292 48.93 280.94 57.79 280.94 57.79"
              fill="inherit"
            />
            <polygon
              points="311.68 106.17 320.31 117.45 331.36 108.59 322.73 97.3 311.68 106.17 311.68 106.17"
              fill="inherit"
            />
          </g>
        </g>
        <path
          d="M184.84,295.77c6.4-36.28-14.61-36.43-44.18-36.43-33.53,0-55.27,5.64-61.93,43.45l-5.21,29.57c-6.53,37.04,10.69,43.17,46.66,43.17,40.85,0,51.85-7.04,58.65-45.6l3.52-19.97h-51.99l-3.74,21.19h21.04c-2.8,15.85-7.53,19.36-23.08,19.36s-22.49-2.13-18.91-22.41l3.28-18.6c3.56-18.44,5.35-25.16,27.3-25.16,9.15,0,19.08-.15,17.65,11.43h30.93Zm55.02-10.52h51.98l4.41-25h-82.47l-20.16,114.32h83.53l4.4-25h-53.05l3.93-22.25h48.78l3.74-21.19h-48.78l3.68-20.89h0v.02Zm113.98-25h-30.49l-20.16,114.32h78.2l4.67-26.52h-47.72l15.49-87.8h0Z"
          fill="inherit"
        />
        <rect y="22.71" width="395.63" height="395.63" fill="none" />
      </g>
    </svg>
  );
}

export default GELExpressLogistikIcon;
